import React, { useEffect, useRef } from 'react'
import { Card, CardContent, CardDescription, CardHeader } from 'components/Card'
import balanceText from 'balance-text'

/**
 *
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} props.name
 * @param {string} props.description
 * @param {*} props.icon
 * @param {(event, object) => void} props.onClick
 */
export default function SurveyTypeButton({ className, name, description, icon, onClick }) {
  const descriptionRef = useRef(null)

  useEffect(() => {
    balanceText(descriptionRef.current)
  }, [descriptionRef])

  return (
    <Card
      as="a"
      fluid
      className={className}
      style={{ maxWidth: 295, textAlign: 'center' }}
      onClick={onClick}
    >
      <div className="flex items-center justify-center">
        <span className="self-center mv4">{icon}</span>
      </div>
      <CardContent className="p3">
        <CardHeader className="h3 mt1">{name}</CardHeader>
        <CardDescription>
          <div ref={descriptionRef}>{description}</div>
        </CardDescription>
      </CardContent>
    </Card>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SurveyTypeButton/index.js